/**
 *
 * Record
 *
 */

import React from "react"
import { map } from "lodash"
import "./index.less"

import { Timeline } from "antd"

const TimelineItem = Timeline.Item

function Record({ dataHistory }) {
  return (
    <Timeline className="timeline">
      {Array.isArray(dataHistory) &&
        map(dataHistory, (item) => {
          return (
            <TimelineItem key={item.id_divisions_log}>
              <span>{item.created_at}</span>
              <p dangerouslySetInnerHTML={{ __html: item.message }} />
            </TimelineItem>
          )
        })}
    </Timeline>
  )
}

Record.propTypes = {}

export default Record
